import { useState, useEffect } from 'react';
import { authFetch } from '../utils/api';

export function useCompany() {
  const [companyName, setCompanyName] = useState('');
  const [loading,     setLoading]     = useState(true);

  useEffect(() => {
    authFetch('/api/health/company')
      .then(r => r.json())
      .then(d => {
        setCompanyName(d.companyName || '');
        setLoading(false);
      })
      .catch(() => {
        setCompanyName('');
        setLoading(false);
      });
  }, []);

  return { companyName, loading };
}